(function ($) {
    $.widget("ui.attrCol", {
        options: {},

        _create: function () {
            let self = this,
                el = self.element,
                hideafter = el.data('hideafter');

            if (!hideafter) return;

            let attrbody = el.find('.attrbody'),
                showmore = el.find('.mfshowmore'),
                showless = el.find('.mfshowless'),
                moreps = attrbody.find('p:gt(' + (hideafter - 1) + ')');

            if (moreps.length) {
                moreps.hide();
                showmore.show().on("click", function () {
                    moreps.slideDown();
                    $(this).hide();
                    showless.show();
                });

                showless.on("click", function () {
                    moreps.slideUp();
                    $(this).hide();
                    showmore.show();
                });
            }
        }
    });
})(jQuery);
